var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrentVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 37,
    viewBox: "0 0 44 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.608 6.47019C30.8176 5.97689 32.198 6.55756 32.6913 7.76714L36.8596 17.9878C37.3529 19.1974 36.7722 20.5778 35.5626 21.0711L26.072 24.9416C25.2656 25.2705 24.3453 24.8834 24.0165 24.077L19.2528 12.3962C18.9239 11.5898 19.311 10.6695 20.1174 10.3407L29.608 6.47019Z",
    fill: "#0E9A26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2622 8.7954C32.6654 8.63097 33.1256 8.82452 33.29 9.22772L36.2673 16.5282C36.4318 16.9314 36.2382 17.3915 35.835 17.556C35.4318 17.7204 34.9717 17.5268 34.8072 17.1236L31.8299 9.82318C31.6655 9.41998 31.8591 8.95983 32.2622 8.7954Z",
    fill: "#464646"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4334 19.8649C36.5946 19.7991 36.6721 19.615 36.6063 19.4538L36.249 18.5777C36.1832 18.4164 35.9992 18.339 35.8379 18.4048L34.9618 18.7621C34.8006 18.8278 34.7231 19.0119 34.7889 19.1732L35.1462 20.0492C35.212 20.2105 35.396 20.2879 35.5573 20.2222L36.4334 19.8649Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6687 8.18226C31.83 8.11648 31.9074 7.93242 31.8416 7.77115L31.4844 6.89509C31.4186 6.73381 31.2345 6.65639 31.0733 6.72216L30.1972 7.07944C30.0359 7.14521 29.9585 7.32927 30.0243 7.49055L30.3816 8.36661C30.4473 8.52788 30.6314 8.60531 30.7927 8.53953L31.6687 8.18226Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1513 10.8823C27.9577 10.5534 28.878 10.9406 29.2069 11.7469L31.5887 17.5873C31.9176 18.3937 31.5304 19.314 30.7241 19.6429L28.5339 20.5361C27.7275 20.8649 26.8072 20.4778 26.4784 19.6714L24.0965 13.8311C23.7677 13.0247 24.1548 12.1044 24.9612 11.7755L27.1513 10.8823Z",
    fill: "#464646"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2016 11.5327C18.008 11.2038 18.9283 11.5909 19.2571 12.3973L24.0208 24.0781C24.3497 24.8845 23.9626 25.8048 23.1562 26.1336L14.3956 29.7064C12.7828 30.3641 10.9422 29.5899 10.2845 27.9771L6.71174 19.2166C6.05401 17.6038 6.82823 15.7632 8.44101 15.1055L17.2016 11.5327Z",
    fill: "white",
    stroke: "#9F9F9F",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentVehicle);
export default __webpack_public_path__ + "static/media/currentVehicle.201298a7776118ee004b084a0afec283.svg";
export { ForwardRef as ReactComponent };